import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {IdentifyTagPage} from './identify-tag';
import {TranslateModule} from "@ngx-translate/core";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';
import {PipesModule} from "../../pipes/pipes.module";
import {ComponentsModule} from "../../components/components.module";
import {NoResultsComponentModule} from "../../components/no-results/no-results.module";

@NgModule({
  declarations: [
    IdentifyTagPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(IdentifyTagPage),
    TranslateModule.forChild(),
    DirectivesModule,
    PipesModule,
    ComponentsModule,
    NoResultsComponentModule
  ],
})
export class IdentifyTagPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/identify-tag/identify-tag.module.ts